import React, { Component } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { connect } from "react-redux";

import Favicon from 'react-favicon';

import Layout from './hoc/Layout/Layout';
import Calendar from './containers/Calendar/Calendar';
import Login from './containers/Login/Login'
import Logout from "./containers/Auth/Logout/Logout";
import { authCheckState, logout } from "./store/actions";
import withErrorHandler from "./hoc/withErrorHandler/withErrorHandler";
import axios from './axios-cmk';
import Reports from "./components/Reports/Reports";
import CMKNavigation from "./components/Navigation/CMKNavigation/CMKNavigation";
import Dashboard from "./components/Dashboard/Dashboard";
import PatientsBoard from "./containers/Patients/PatientsBoard";

class App extends Component {

    componentDidMount() {
        this.props.onTryAutoSignup();
    }

    render() {

        if (this.props.should_logout) {
            this.props.logout()
        }

        let routes = null;
        if (this.props.isAuthDone) {
            routes = (
                <Switch>
                    <Route path="/login" component={Login} />
                    <Redirect to="/login" />
                </Switch>
            );

            if (this.props.isAuthenticated) {
                routes = (
                    <Switch>
                        <Route path="/login" component={Login} />
                        <Route path="/logout" component={Logout} />
                        <Route path="/calendar" component={Calendar} />
                        <Route path="/reports" component={Reports} />
                        <Route path="/dashboard" component={Dashboard} />
                        <Route path="/patients" component={PatientsBoard}/>
                    </Switch>
                );
            }
        }
        return (
            <div>
                <Favicon url="https://cmk.arue.pl/static/favicon.png" />
                <Layout>
                    <CMKNavigation />
                    {routes}
                </Layout>
                <div className="divFooter">
                    Copyright © 2018, Centrum Metody Krakowskiej
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null,
        isAuthDone: state.auth.isAuthDone
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onTryAutoSignup: () => dispatch(authCheckState()),
        logout: () => dispatch(logout())
    };
};

export default withRouter(withErrorHandler(connect(mapStateToProps, mapDispatchToProps)(App), axios));



// WEBPACK FOOTER //
// ./src/App.js